import {createStyles, FormControl, withStyles} from "@material-ui/core";
import {withRouter} from "next/router";
import * as React from "react";
import {WithRouterProps} from "next/dist/client/with-router";
import SearchFacets from "./SearchFacets";

const sectionsFilterStyles = createStyles((theme: any) => ({
    sectionsFilter: theme.sectionsFilter,
    sectionsFilterWrapper: theme.sectionsFilterWrapper
}));

interface ISectionsFilterProps extends WithRouterProps {
    classes?: any;
    onChangeSections: (type: string, new_sections: any[]) => void;
    selectedFacets: any[];
    siteSections: any[];
    searchFacets: any;
    selectClasses?: any[];
    runtimeConfig?: any;
}

/**
 * The goal of this function is to convert an API structure for sections or taxonomy to a 
 * structure used by the portal.
 * 
 * This function munges 'id', by joining it's parent ids with a space. Because of this, `originaId` 
 * was added, which in the case of taxonomy, this is the original taxonomy id (also called name).
 * This originalId is used later for localizing these terms.
 */
const mapToRootNode = (facet, parentVal = null, rootParam = null) => {
    if (facet && facet.versions && facet.versions.length) {
        facet.children = facet.versions;
    }
    const originalId = facet.id;
    if (facet && facet.children && facet.children.length === 1) {
        let child = facet.children[0];
        let childVal = child.href || child.id || child.value;
        let parentVal = facet.href || facet.id || facet.label;
        if (childVal && parentVal) {
            const same = childVal.indexOf(parentVal) !== -1;
            if (same) {
                let id = child.href || child.id || child.title;
                if (rootParam !== 'facet_section' && parentVal) {
                    id = `${parentVal} ${id}`
                }
                facet = {
                    param: facet.param,
                    title: facet.title || facet.id,
                    id,
                    children: child.children
                }
            } else {
                facet.children = null
            }
        }
    }
    let value = facet.href || facet.id
    if (rootParam !== 'facet_section') {
        if (parentVal) {
            value = `${parentVal} ${value}`
        }
        parentVal = value;
    }
    return {
        value,
        param: facet.param,
        isUiLabel: facet.isUiLabel,
        label: facet.title || facet.label || facet.id,
        originalId: originalId,
        children: (facet.children && facet.children.length) ? facet.children.filter((c) => c.searchable == true || c.searchable === undefined).map((c) => mapToRootNode(c, parentVal, rootParam)) : null
    } as any;
}
const SectionsFilter = (props: ISectionsFilterProps) => {
    const expandedSections = props.searchFacets.map((f) => f.id);
    const selected = props.router?.query && Object.entries(props.router.query).reduce((acc, [k, v]) => {
        if (k.startsWith('facet_')) {
            if (Array.isArray(v)) {
                v.forEach((sv) => acc.push(sv))
            } else {
                acc.push(v);
            }
        }
        return acc;
    }, []) || [];
    const searchFacetValues = props.searchFacets.filter((c) => c.searchable == true || c.searchable === undefined).map((c) => mapToRootNode(c, null, c.param))

    const facets = props.runtimeConfig.search?.facets;
    const facetsAdvancedSettings = props.runtimeConfig.search?.facetsAdvancedSettings;
    if(facetsAdvancedSettings?.order){
        // new config
        let sortingArray = Array.from( new Map(Object.entries(facetsAdvancedSettings.order)).keys())
        if (sortingArray) {
            searchFacetValues.sort((a, b) => {
                // This allows us to order the search facets as we declare them in the runtime config.
                // Any facets not declared in the config map/array will always appear first, which is expected behavior. 
                // The facets declared in the runtime config are additional facets, we'd want any default facets to appear first.
                // The first value listed in the string will match the value given in the runtime configs search facets array.
                let aValue = a.value.split(' ')[0];
                let bValue = b.value.split(' ')[0];
                return sortingArray.indexOf(aValue) - sortingArray.indexOf(bValue)
            });
        }
    } else if (facets) {
        // old config
        const sortingArray = props.runtimeConfig.search?.facets;
        searchFacetValues.sort((a, b) => 
        {
            // This allows us to order the search facets as we declare them in the runtime config.
            // Any facets not declared in the array (like "sections") will always appear first, which is expected behavior. 
            // The facets declared in the runtime config are additional facets, we'd want any default facets to appear first.
            // The first value listed in the string will match the value given in the runtime configs search facets array.
            let aLabel = a.value.split(' ')[0];
            let bLabel = b.value.split(' ')[0];
            return sortingArray.indexOf(aLabel) - sortingArray.indexOf(bLabel)
        });
    }

    const {classes} = props;

    return (
        <FormControl className={classes.sectionsFilter}>
            <div className={classes.sectionsFilterWrapper}>
                {searchFacetValues.map((root) => {
                    let sortingChildren;
                    if (facetsAdvancedSettings?.order) {
                        const children = new Map(Object.entries(facetsAdvancedSettings?.order)).get(root.value)
                        if(children && Object.keys(children).length) {
                            sortingChildren = children
                        }
                    }
                    return <SearchFacets
                        key={root.param}
                        root={root}
                        selected={selected}
                        onChange={(selected) => props.onChangeSections(root.param, selected)}
                        initiallyExpanded={expandedSections}
                        isTaxonomy={root.param !== 'facet_section'}
                        sorting={sortingChildren}
                    />
                })}
            </div>
        </FormControl>
    );
};

SectionsFilter.defaultProps = {
    siteSections: [],
    searchFacets: [],
    facetValuesInfoType: []
}

export default withRouter(withStyles(sectionsFilterStyles, {name: "SectionsFilter"})(SectionsFilter));
